// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__29x3d","signatureBlock":"Footer_signatureBlock__4-ybD","signature":"Footer_signature__2t6qN"};